module.exports = __webpack_public_path__ + "img/92_off.34364108.png";